var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoGears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 247.93 202.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-9);}.cls-9{fill:url(#linear-gradient-11);}.cls-10{fill:url(#linear-gradient-12);}.cls-11{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 114.81,
    y1: -60.66,
    x2: 114.81,
    y2: 259.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a8fd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 119.35,
    y1: -60.66,
    x2: 119.35,
    y2: 259.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 110.76,
    y1: -60.66,
    x2: 110.76,
    y2: 259.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 110.76,
    y1: -60.66,
    x2: 110.76,
    y2: 259.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 128.47,
    y1: -60.66,
    x2: 128.47,
    y2: 259.26,
    gradientTransform: "translate(122.45 -60.55) rotate(48.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 57.55,
    y1: -60.66,
    x2: 57.55,
    y2: 259.26,
    gradientTransform: "translate(62.56 -21.77) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 110.76,
    y1: -60.66,
    x2: 110.76,
    y2: 259.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 37.77,
    y1: -60.66,
    x2: 37.77,
    y2: 259.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 24.34,
    y1: -60.66,
    x2: 24.34,
    y2: 259.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 194.42,
    y1: -60.66,
    x2: 194.42,
    y2: 259.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 190.08,
    y1: -60.66,
    x2: 190.08,
    y2: 259.26,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.76,203a77.24,77.24,0,0,1-69.57-43.12L47,157a71.16,71.16,0,1,0,.07-63.41l-5.84-2.91A77.67,77.67,0,1,1,110.76,203Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.76,184A58.26,58.26,0,0,1,69.53,167l4.59-4.64a52.11,52.11,0,1,0-.2-73.89l-4.61-4.61A58.63,58.63,0,1,1,110.76,184Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.76,164.92a39.6,39.6,0,0,1,0-79.19v6.52a33.07,33.07,0,1,0,33.07,33.08h6.53A39.64,39.64,0,0,1,110.76,164.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.76,138.09a12.77,12.77,0,1,1,12.77-12.76A12.78,12.78,0,0,1,110.76,138.09Zm0-19a6.25,6.25,0,1,0,6.25,6.25A6.25,6.25,0,0,0,110.76,119.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 111.52,
    y: 102.44,
    width: 33.9,
    height: 6.52,
    transform: "translate(-35.83 131.82) rotate(-48.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 54.29,
    y: 58.39,
    width: 6.52,
    height: 12.48,
    transform: "translate(-28.84 59.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 107.5,
    y: 30.75,
    width: 6.52,
    height: 16.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 99.31,
    y: 27.49,
    width: 22.92,
    height: 6.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 13.43,
    y: 104.84,
    width: 48.67,
    height: 6.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 13.43,
    y: 139.29,
    width: 48.67,
    height: 6.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    y: 122.07,
    width: 48.67,
    height: 6.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M216.54,115.79l-11.49-10.56a46.76,46.76,0,0,1-4.5,1.7l-2-6.21a39.87,39.87,0,0,0,5.62-2.29l2-1,10.68,9.82,5.89-4.63-7-12.69,1.45-1.72a40.15,40.15,0,0,0,7.47-13.31l.71-2.13,14.52-.61.89-7.44-14-4-.18-2.23a40.56,40.56,0,0,0-4.1-14.71l-1-2,9.82-10.67-4.63-5.9-12.7,7-1.72-1.45A40.25,40.25,0,0,0,199,23.26l-2.12-.72L196.28,8l-7.44-.89-4,14-2.23.19a40.51,40.51,0,0,0-14.71,4.1l-2,1-10.67-9.82-5.89,4.63,7,12.69-1.45,1.72a40.39,40.39,0,0,0-4.27,6.15l-5.68-3.21a48.07,48.07,0,0,1,3.55-5.38l-7.54-13.67L155.52,8,167,18.58A46.69,46.69,0,0,1,179.78,15l4.34-15,18.44,2.22.66,15.62a46.6,46.6,0,0,1,11.55,6.48l13.68-7.54,11.47,14.61L229.36,42.88a46.79,46.79,0,0,1,3.55,12.77l15,4.34-2.21,18.44-15.62.66a46.73,46.73,0,0,1-6.49,11.56l7.55,13.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M201.44,83.64l-4-5.12a20.1,20.1,0,1,0-24.83-31.61l-4-5.13a26.61,26.61,0,1,1,32.88,41.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoGears);
export default __webpack_public_path__ + "static/media/twoGears.cd3b9c5145f5229136024dced917d27e.svg";
export { ForwardRef as ReactComponent };